// feature template-inspection
import truckSectionConfig from './truck-section-config';
import trailerSectionConfig from './trailer-section-config';
import {
  boxTruck1AxleSectionConfig,
  boxTruck2AxleSectionConfig,
} from './box-truck-axle-section-config';
//////////////////////////////////////////////////

const vehicleTypesConfig = {
  ...truckSectionConfig,
  ...trailerSectionConfig,
  ...boxTruck1AxleSectionConfig,
  ...boxTruck2AxleSectionConfig,
};

export default vehicleTypesConfig;
